import React from 'react';
import { FooterFeature } from '@app/src/common/footer';
import { Wrapper } from './styled';
import { CoverPage, CategorySlider, FindUs } from '@app/src/views/Home/listProducts';
import { HeaderFeature } from '@app/src/common/header';

export const ListProducts: React.FC = () => {
  return (
    <React.Fragment>
      <Wrapper>
        <HeaderFeature />
        <CoverPage />
        <CategorySlider />
        <FindUs />
        <FooterFeature isDisplay={true} showSecurity={true} />
      </Wrapper>
    </React.Fragment>
  )
};

ListProducts.displayName = 'ListProducts';
